import { Circle } from 'react-yandex-maps'

import { usePainter } from '../../model/store/painter.store'

export const Painter = () => {
  const painterObject = usePainter()
  if (!painterObject) {
    return null
  }
  return (
    <Circle
      geometry={[painterObject.coordinates, painterObject.radius]}
      options={{
        draggable: false,
        fillColor: '#193A42',
        fillOpacity: '0.3',
        strokeColor: '011F2688',
        strokeStyle: 'dash',
        strokeWidth: 2,
        strokeOpactity: '0.5',
        interactivityModel: 'default#transparent',
        cursor: 'crosshair'
      }}
    />
  )
}
